import { OAuth2TokenResponse } from '@applyboard/school-backend-lib'
import { LocalStorage } from '../LocalStorage'

enum StorageKeys {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  OktaTokenStorage = 'okta-token-storage',
}

export class AuthStorage {
  static setAuthCredentials({ id_token, refresh_token }: OAuth2TokenResponse): void {
    // TODO: Update all the frontend auth code to refer to idToken instead of accessToken
    AuthStorage.setAccessToken(id_token)

    if (refresh_token) {
      AuthStorage.setRefreshToken(refresh_token)
    }
  }

  static removeAuthCredentials(): void {
    LocalStorage.removeItem(StorageKeys.RefreshToken)
    LocalStorage.removeItem(StorageKeys.AccessToken)
  }

  static setAccessToken(newToken: string): void {
    LocalStorage.setItem(StorageKeys.AccessToken, newToken)
  }

  static setRefreshToken(newToken: string): void {
    LocalStorage.setItem(StorageKeys.RefreshToken, newToken)
  }

  static getCognitoAccessToken(): string {
    try {
      const item = LocalStorage.getItem(StorageKeys.AccessToken)
      return item
    } catch (err) {
      return ''
    }
  }

  static getOktaAccessToken(): string {
    try {
      const item = JSON.parse(LocalStorage.getItem(StorageKeys.OktaTokenStorage)).accessToken
        .accessToken
      return item
    } catch (err) {
      return ''
    }
  }

  static getAccessToken(): string {
    return this.getCognitoAccessToken().length
      ? this.getCognitoAccessToken()
      : this.getOktaAccessToken()
  }

  static getRefreshToken(): string {
    try {
      const item = LocalStorage.getItem('refreshToken')
      return item
    } catch (err) {
      return ''
    }
  }
}
